import { createBrowserClient } from '@supabase/ssr'
import type { Client } from '@bnsn/supabase'
import invariant from 'tiny-invariant'

import getEnv from '~/core/get-env'
import type { Database } from '../../database.types'

let client: Client | undefined

export function getSupabaseBrowserClient(): Client {
  if (client) {
    return client
  }

  const env = getEnv()

  const supabaseUrl = env?.SUPABASE_URL ?? import.meta.env.VITE_SUPABASE_URL
  const supabaseAnonKey = env?.SUPABASE_ANON_KEY ?? import.meta.env.VITE_SUPABASE_ANON_KEY

  invariant(supabaseUrl, `Supabase URL was not provided`)
  invariant(supabaseAnonKey, `Supabase Anon key was not provided`)

  // `@supabase/ssr` 0.3.0 returns the legacy 3-parameter `SupabaseClient`
  // shape; cast through `unknown` to the canonical `Client` so consumers
  // see a uniform `SupabaseClient<Database>` type.
  client = createBrowserClient<Database>(supabaseUrl, supabaseAnonKey) as unknown as Client

  return client
}
